import { useEffect, useState } from 'react';
import breakpoints from '@designSystem/breakpoints';

type WindowWidthI = {
  width: number;
  isMobileView: boolean;
};

const useWindowWidth = (): WindowWidthI => {
  const [width, setWindowWidth] = useState(0);
  const updateDimensions = () => {
    window.requestAnimationFrame(() => {
      setWindowWidth(window.innerWidth);
    });
  };

  useEffect(() => {
    updateDimensions();

    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const isMobileView = width < parseInt(breakpoints.large.slice(0, -2));

  return { width, isMobileView };
};

export default useWindowWidth;
